import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators'
import store from '@/store'

export interface IScanforSixScan {
  trueThingCode: string //实物条码
  noReadLablel: number //无读数量
  noLittleNoLabel:number //无格口
  overTimeLabel:number //超时无格口
  manyCodeLabel:number //多条码
  LittleNoLabel:number //有格口
  newSixScanInterface:boolean
}

@Module({ dynamic: true, store, name: 'store_scanforsixscan' })
class ScanforSixScan extends VuexModule implements IScanforSixScan {
  public trueThingCode = "";
  public noReadLablel = 0;
  public noLittleNoLabel = 0;
  public overTimeLabel = 0;
  public manyCodeLabel = 0;
  public LittleNoLabel = 0;
  public newSixScanInterface = false;

  @Mutation
  public setTrueThingCode(str) {
    this.trueThingCode = str;
  }
  @Mutation
  public setNoReadLablel(num) {
    this.noReadLablel = num;
  }
  @Mutation
  public setNoLittleNoLabel(num) {
    this.noLittleNoLabel = num;
  }
  @Mutation
  public setOverTimeLabel(num) {
    this.overTimeLabel = num;
  }
  @Mutation
  public setManyCodeLabel(num) {
    this.manyCodeLabel = num;
  }
  @Mutation
  public setLittleNoLabel(num) {
    this.LittleNoLabel = num;
  }

  @Mutation
  public setSixScanState(num) {
    debugger;
    this.newSixScanInterface = num;
  }


  // @Action
  // public async GetUserInfo() {
  //     const name = "data.user";
  // }

}

export const ScanforSixScanModule = getModule(ScanforSixScan)
